import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useFollowUp from '@hook/alerts/use-followup'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelAlertFollowUpExport: FC<ILayoutToolsExportAction> = () => {
  const { isDisabled } = useTools()
  const { exportData } = useFollowUp()
  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled}
      onClick={exportData}
      icon={<GrDocumentCsv />}
    >
      Exportar para Tabela
    </MenuItem>
  )
}

export default ActionExcelAlertFollowUpExport
